var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stats)?_c('OutReach24HourPerformance',{attrs:{"opens":_vm.opens,"clicks":_vm.clicks,"labels":_vm.labels,"loading":_vm.loading}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }